import { FormattedMessage } from 'react-intl';
import * as React from 'react';

export const messages = {
  COMPLETED: <FormattedMessage id="signing-completed" defaultMessage="Completed!" />,
  WE_WILL_SEND_COPY: (
    <FormattedMessage
      id="we-will-send-copy"
      defaultMessage="We will send you a copy when all signees have signed."
    />
  ),
  VIEW_DOCUMENTS: (
    <FormattedMessage
      id="view-documents"
      defaultMessage="View Documents"
    />
  ),
  CLOSE_WINDOW: (
    <FormattedMessage
      id="close-window"
      defaultMessage="Close Window"
    />
  ),
};
